import React from "react";
import moment from "moment";
import { connect } from "react-redux";

// componentes customizados
import { Column } from "primereact/column";
import { DriverForm } from './DriverForm';
import { routes } from '../../../constants';
import { Page } from "../../../components/page/Page";
import Toolbar from "../../../components/toolbar/Toolbar";

// ações e serviços
import storage from '../../../services/stoage.service';
import { actions } from "../driver.actions";
import { actions as carrierActions } from "../../carrier/carrier.actions";
import { makeMessages, messageActions } from "../../../store/message";



const mapStateToProps = state => {
  let record = state.crudDriverState.currentRecord;


  console.log(" mapStateToProps record ==> ", record)

  const lookupCarrierBase = {
    records: state.crudCarrierState.records,
    columFields: state.crudCarrierState.columns,
    columns: state.crudDriverState.lookupCarrier.visible
      ? state.crudCarrierState.columns
        .filter(
          col => col.field === "oid" || col.field === "tradeName" || col.field === "name"
        )
        .map((col, index) => <Column key={index} {...col} />)
      : [<Column key={"columnKeyCarrier"} />],
    first: state.crudCarrierState.index,
    rows: state.crudCarrierState.max,
    totalRecords: state.crudCarrierState.count,
    sortField: state.crudCarrierState.sortField,
    order: state.crudCarrierState.sortOrder,
    visible: state.crudDriverState.lookupCarrier.visible,
    rowsPerPageOptions: [20, 50, 100],
    editDisabled: true,
    modal: false
  };

  const lookupCarrier = Object.assign(
    {},
    state.crudDriverState.lookupCarrier,
    lookupCarrierBase
  );

  return {
    record,
    lookupCarrier,
    // btnSaveIsDisabled,
  };
};

const mapDispatchToProps = dispatch => {
  const _setField = (field, value) => {
    dispatch(actions.setField(field, value));
  }

  return {

    changeHandler: event => {
      const target = event.target;
      const field = target.name;
      let value = target.value;

      if (typeof value === 'string' && field != 'password') {
        value = value.toUpperCase();
      }

      dispatch(actions.removeErrors([{ field }]));
      _setField(field, value);
    },
    saveHandler: () => {
      dispatch(actions.saveDriver());
    },
    removeHandler: event => {
      dispatch(actions.remove());
    },
    newHandler: event => {
      dispatch(actions.setRecord({}))
      dispatch(actions.clearDriverSetNew())
    },

    loadById: oid => {
      dispatch(actions.setRecord(null))
      dispatch(actions.loadById(oid))
    },

    setField: (field, value) => {
      _setField(field, value)
    },

    sendMessageError: (message, messageType) => dispatch(
      messageActions.messageShowMessages(
        makeMessages([message], messageType)
      ),
    ),

    changeValidateCNHHandler: value => dispatch(actions.setValidateCNH(value)),

    lookupCarrierLoad: () => dispatch(carrierActions.load()),
    lookupCarrierSetVisible: visible => dispatch(actions.setVisibleLookupCarrier(visible)),
    lookupCarrierPaginate: paginationParams => dispatch(carrierActions.paginate(paginationParams)),
    lookupCarrierSortOrder: sortParams => dispatch(carrierActions.sortOrder(sortParams)),
    lookupCarrierApplyFilter: filterParams => {
      dispatch(carrierActions.setType(null));
      dispatch(carrierActions.applyFilter(filterParams));
    },
    setCarrierFilter: carrier => {
      dispatch(actions.setCarrier(carrier));
    },

  }
};

class DriverFormPageContainer extends React.Component {

  constructor(props) {
    super(props);
    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_DRIVER}/${oid}`);
    };
    actions.afterNew = () => {
      this.props.newHandler();
      this.props.history.replace(`${routes.PATH_DRIVER}/novo`);
    };
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_DRIVER}`);
    };
  }

  componentDidMount() {
    const oid = this.props.match.params.id;

    if (oid && parseInt(oid)) {
      this.props.loadById(oid);
    } else {
      this.props.newHandler();
      // this.props.history.replace(`${routes.PATH_DRIVER}/novo`);
    }
  }
  searchHandler = () => {
    this.props.history.push(`${routes.PATH_DRIVER}`)
  }

  onSaveHandler = () => {
    if (this.props.record.carrier && this.props.record.carrier.documentNumber !== "") {
      this.props.saveHandler();
    } else {
      this.props.sendMessageError(["Não está selecionado a transportadora."], "error");
    }
  }

  onChangeValidateCNHHandler = (e) => {
    const value = moment(e.value, 'DD/MM/YYYY').toDate();
    this.props.changeValidateCNHHandler(value)
  }


  changeHandler = (e) => {
    console.log("changeHandler:", e)
    this.props.changeHandler(e);
  }

  lookupCarrierOnPage = e => {
    this.props.lookupCarrierPaginate({
      max: e.rows,
      index: e.first
    });
  };
  lookupCarrierOnSort = e => {
    this.props.lookupCarrierSortOrder({
      sortOrder: e.sortOrder,
      sortField: e.sortField
    });
  };
  lookupCarrierOnFilter = e => {
    const filters = [];
    const keys = Object.keys(e.filters) || [];
    keys.forEach(key => {
      filters.push({
        campo: key,
        valor: e.filters[key].value,
        tipoFiltro: "CONTEM"
      });
    });
    this.props.lookupCarrierApplyFilter(filters);
  };
  lookupCarrierOnClick = e => {
    this.props.lookupCarrierApplyFilter([]);
    this.props.lookupCarrierLoad();
    this.props.lookupCarrierSetVisible(true);
  };
  lookupCarrierOnHide = e => {
    this.props.lookupCarrierApplyFilter([]);
    this.props.lookupCarrierSetVisible(false);
  };
  lookupCarrierOnConfirm = e => {
    this.props.lookupCarrierApplyFilter([]);
    this.props.setCarrierFilter(e.selection);
    this.props.lookupCarrierSetVisible(false);
  };
  lookupCarrierOnCancel = e => {
    this.props.lookupCarrierApplyFilter([]);
    this.props.setCarrierFilter(null);
    this.props.lookupCarrierSetVisible(false);
  };

  lookupCarrierOnComplete = e => {
    //this.props.lookupCarrierApplyFilter([])
  };

  lookupCarrierOnInputFilter = e => {
    const value = e.value;
    if (typeof value === "string") {
      const filters = [
        {
          campo: "tradeName",
          valor: e.value,
          tipoFiltro: "CONTEM"
        }
      ];
      this.props.setCarrierFilter({ name: value });
      this.props.lookupCarrierApplyFilter(filters);
    } else {
      this.props.setCarrierFilter(value);
    }
  };

  render() {
    const title = `Motorista ${this.props.record.oid || 'novo'}`
    const header = (
      <div>
        <h1>{title}</h1>
        <div>
          <Toolbar
            // btnSaveIsDisabled={this.props.btnSaveIsDisabled}
            btnRemoveIsDisabled={this.props.record.oid ? false : true}

            onSave={this.onSaveHandler} saveButtonStyle='highlighted'
            onRemove={this.props.removeHandler} removeButtonStyle='danger'
            onNew={this.props.newHandler}
            onSearch={this.searchHandler}>
          </Toolbar>
        </div>
      </div>
    );

    const content = (
      <DriverForm
        record={this.props.record}
        changeHandler={this.changeHandler}
        changeValidateCNHHandler={this.onChangeValidateCNHHandler}
        lookupCarrier={this.props.lookupCarrier}
        lookupCarrierOnComplete={this.lookupCarrierOnComplete}
        lookupCarrierOnInputFilter={this.lookupCarrierOnInputFilter}
        lookupCarrierOnEdit={this.lookupCarrierOnEdit}
        lookupCarrierOnClick={this.lookupCarrierOnClick}
        lookupCarrierOnConfirm={this.lookupCarrierOnConfirm}
        lookupCarrierOnCancel={this.lookupCarrierOnCancel}
        lookupCarrierOnPage={this.lookupCarrierOnPage}
        lookupCarrierOnFilter={this.lookupCarrierOnFilter}
        lookupCarrierOnSort={this.lookupCarrierOnSort}
        lookupCarrierOnHide={this.lookupCarrierOnHide}
      />);
    return (<Page header={header} content={content} />);
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DriverFormPageContainer);
